const baseURL = 'https://strapi.globalshipping.watch'

export const getURL = (url) => {
    return baseURL + url
}

export const fetchData = async (endpoint) => {
    const response = await fetch(`${baseURL}/${endpoint}`)
    const data = await response.json()
    if (response.ok) {
        return data
    } else {
        throw new Error(data)
    }
}